import * as React from 'react';
import { useSelector } from 'react-redux';

import { RedesignedFiltersPanelId } from './index';
import * as styles from './styles.css';
import { EListingModalMode } from '../../../common/actions/listingModal';
import { ETestId } from '../../../common/constants';
import { ExpSearchStringAndFastFilters } from '../../../common/constants/config/declarations';
import { useApplicationContext } from '../../../common/containers/ApplicationContext';
import { SearchStringMicrofrontend } from '../../../common/containers/SearchStringMicrofrontend';
import { selectIsModalOpen, selectModalMode } from '../../../common/selectors/listingModal';
import { useIsSearchStringExperimentAvailable } from '../../../common/utils/experiments';
import { SearchStringPanel } from '../../components/RedesignedFilters';
import { FILTER_COMPONENTS } from '../../constants/filtersComponents';
import { FiltersRedesignContext } from '../../context';
import { useDisableSearchStringPlaceholder } from '../../hooks/useDisableSearchStringPlaceholder';
import { useFiltersList } from '../../hooks/useFiltersList';
import { useQuickFiltersScrollState } from '../../hooks/useQuickFiltersScrollState';
import { useSearchStringFiltersClick } from '../../hooks/useSearchStringFiltersClick';
import { useSearchStringView } from '../../hooks/useSearchStringView';
import { EMobileFilters } from '../../types/filters';

const FiltersChips = ({ withFiltersButton = true }: { withFiltersButton?: boolean }) => {
  const filtersList = useFiltersList();
  const filters = withFiltersButton
    ? filtersList
    : filtersList.filter(filterKey => filterKey !== EMobileFilters.moreFilters);

  return (
    <>
      {filters.map(filterKey => {
        const Component = FILTER_COMPONENTS[filterKey];

        return <Component key={filterKey} />;
      })}
    </>
  );
};

const CurrentChipsRow = () => (
  <div className={styles['chips']}>
    <FiltersChips />
  </div>
);

const RedesignedChipsPanel = () => {
  const { config } = useApplicationContext();
  const isListingOpen = useSelector(selectIsModalOpen);
  const listingMode = useSelector(selectModalMode);
  const isListingExpanded = isListingOpen && listingMode === EListingModalMode.FULL_SCREEN;

  useSearchStringView(isListingExpanded);
  useSearchStringFiltersClick();
  useDisableSearchStringPlaceholder(isListingExpanded);
  const isFiltersHidden = useQuickFiltersScrollState(isListingExpanded);
  const isAnimationForced = Boolean(config.get<boolean>('BX.SearchStringAnimationForced.Enabled'));

  return (
    <FiltersRedesignContext.Provider value={true}>
      <SearchStringPanel
        isExpanded={isListingExpanded}
        isFiltersHidden={isFiltersHidden}
        isAnimationForced={isAnimationForced}
        searchString={<SearchStringMicrofrontend isStretched={isListingExpanded} />}
        // Полноразмерная строка несёт свою иконку фильтров, поэтому отдельная кнопка рядом лишняя
        filters={<FiltersChips withFiltersButton={!isListingExpanded} />}
      />
    </FiltersRedesignContext.Provider>
  );
};

export const RedesignedFiltersPanelContainer = () => {
  const isExperimentAvailable = useIsSearchStringExperimentAvailable();

  return (
    <section id={RedesignedFiltersPanelId} data-testid={ETestId.RedesignedFiltersSectionTestId}>
      {isExperimentAvailable ? (
        <ExpSearchStringAndFastFilters>
          <ExpSearchStringAndFastFilters.Group name="A">
            <CurrentChipsRow />
          </ExpSearchStringAndFastFilters.Group>
          <ExpSearchStringAndFastFilters.Group name="B">
            <RedesignedChipsPanel />
          </ExpSearchStringAndFastFilters.Group>
        </ExpSearchStringAndFastFilters>
      ) : (
        <CurrentChipsRow />
      )}
    </section>
  );
};
